//import * as React from 'react';
import React, { useState } from 'react';
//import FormControl from '@mui/material/FormControl'; // { useFormControl }
//import OutlinedInput from '@mui/material/OutlinedInput';
//import FormHelperText from '@mui/material/FormHelperText';
//import Box from '@mui/material/Box';
//import TextField from '@mui/material/TextField';
import Button from "components/CustomButtons/Button";
/*

function MyFormHelperText() {
  const { focused } = useFormControl() || {};

  const helperText = React.useMemo(() => {
    if (focused) {
      return 'This field is being focused';
    }

    return 'Helper text';
  }, [focused]);

  return <FormHelperText>{helperText}</FormHelperText>;
}
*/

export default function JobApplicationForm(position) {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
    coverLetter: null,
    resume: null,
    comments: '',
    position: position.position
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'coverLetter' || name === 'resume') {
      setFormData({
        ...formData,
        [name]: files[0],
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    console.log("position");
    console.log(position);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Here you can handle form submission, e.g., send the data to a server
    console.log('Form submitted:', formData);
  
      const zapierWebhookURL = 'https://hooks.zapier.com/hooks/catch/4366710/2y66k5d/';
  
      // Create a FormData object to hold form data
      const formSubmission = new FormData();
      formSubmission.append('firstName', formData.firstName);
      formSubmission.append('lastName', formData.lastName);
      formSubmission.append('phoneNumber', formData.phoneNumber);
      formSubmission.append('email', formData.email);
      formSubmission.append('resume', formData.resume);
      formSubmission.append('coverLetter', formData.coverLetter);
      formSubmission.append('comments', formData.comments);
      formSubmission.append('position', formData.position);
      try {
        // Send form data to Zapier webhook
        const response = await fetch(zapierWebhookURL, {
          method: 'POST',
          body: formSubmission
        });
  
        if (response.ok) {
          alert('Your application was submitted successfully!');
          window.location.reload();
        } else {
          alert('There was an error submitting your application. Please try again, or email your resume directly to careers@wevett.com');
        }
      } catch (error) {
        console.error('Error submitting form:', error);
        alert('There was an error submitting your application. Please try again, or email your resume directly to careers@wevett.com');
      }
    
  };

  return (
    <form onSubmit={handleSubmit} >
      <div  >
        <label htmlFor="firstNameApp">First Name:</label>
        <input
          type="text"
          id="firstNameApp"
          name="firstName"
          value={formData.firstName}
          onChange={handleChange}
          required
        />
      </div>
      <div  >
        <label htmlFor="lastNameApp">Last Name:</label>
        <input
          type="text"
          id="lastNameApp"
          name="lastName"
          value={formData.lastName}
          onChange={handleChange}
          required
        />
      </div>
      <div  >
        <label htmlFor="phoneNumber">Phone Number:</label>
        <input
          type="tel"
          id="phoneNumber"
          name="phoneNumber"
          value={formData.phoneNumber}
          onChange={handleChange}
          required
        />
      </div>
      <div  >
        <label htmlFor="emailAddr">Email:</label>
        <input
          type="email"
          id="emailAddr"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </div>
      <div  >
        <label htmlFor="coverLetter">Attach Cover Letter:</label>
        <input
          type="file"
          id="coverLetter"
          name="coverLetter"
          onChange={handleChange}
          
        />
      </div>
      <div  >
        <label htmlFor="resume">Attach Resume:</label>
        <input
          type="file"
          id="resume"
          name="resume"
          onChange={handleChange}
          
        />
      </div>
      <div className="fullwidth" >
        <label htmlFor="comments">Comments:</label>
        <textarea
          id="comments"
          name="comments"
          value={formData.comments}
          onChange={handleChange}
        />
      </div>
      <input type="hidden" value={position.position} />
      <Button type="submit" color="secondary">
        Submit
      </Button>
    </form>
  );
};
